/*
 * Owner, 2026-09-25: "First we say sign in, then it sends me to the login page. Is that needed?" — it is not. The
 * sign-in page of Zagru One is the identity provider's form (ADR-0042, ADR-0050), so `/login` goes there on its own:
 * on a first visit, after a deep link, after signing out and when a session has expired.
 *
 * A failure is the one case that could loop (the identity provider answers the same error again at once), so after a
 * failure the redirect is tried once more and then the page waits for the person with the failure explained.
 */

const RETRY_KEY = 'zagru.auth.autoRetryAt';
const RETRY_WINDOW_MS = 60_000;

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.sessionStorage;
  } catch {
    return null;
  }
}

export const autoSignInRetry = {
  /** True when no automatic retry has been made in the last minute. */
  allowed(now = Date.now()): boolean {
    const at = Number(storage()?.getItem(RETRY_KEY) ?? 0);
    return !Number.isFinite(at) || now - at > RETRY_WINDOW_MS;
  },
  mark(now = Date.now()): void {
    storage()?.setItem(RETRY_KEY, String(now));
  },
  clear(): void {
    storage()?.removeItem(RETRY_KEY);
  },
};
